import { HoursToGetReady } from 'types/HoursToGetReady';
import branchAxiosaApi from './branchAxiosaApi';
import { BranchResponse } from 'types/branch';

export const getBranches = async (): Promise<BranchResponse> => {
  const { data } = await branchAxiosaApi.get<BranchResponse>('/branches');
  return data;
};

export const branchHoursToGetReady = async (
  branchId: string
): Promise<HoursToGetReady> => {
  const { data } = await branchAxiosaApi.get<HoursToGetReady>(
    `/branches/validate-branch/${branchId}`
  );
  return data;
};
